var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('zj-layout-container',[_c('zj-layout-header'),_c('zj-layout-main',[_c('div',{staticClass:"echart"},[_c('div',{staticClass:"echart_1"},[_c('div',[_vm._v(" 年客流走势 "),_c('LineEchartsTicket',{attrs:{"title":"","xAxisName":"","yAxisName":"","chartData":_vm.usePerData}})],1)])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }